import { theme } from '../theme/theme'

export function isMobile(width: number): boolean {
  return width < theme.sizes.brand.breakPoint
}

export function isTablet(width: number): boolean {
  return width >= theme.sizes.brand.tabletBreakPoint && isMobile(width)
}
